<template>
  <div class="footers">
    <div class="footers-t" :class="[inSearchPage && 'border-top']">
      <div class="social-ul">
        <div
          v-for="(item, index) in media_module"
          :key="index"
          class="social-li"
          @click="
            SDHomeSocialmedia_Click(
              'media_' + index,
              item.jump_target.Jump_target,
              item.jump_target.jump_type,
            )
          "
        >
          <a
            v-if="item.jump_target?.jump_type == 4"
            :href="item.jump_target.Jump_target"
            :aria-label="`Vooglam ${item.jump_target.Jump_target}`"
            target="_blank"
          >
            <NuxtImgWrap
              :src="item.jump_image"
              :alt="`Vooglam ${item.jump_target.Jump_target}`"
              loading="lazy"
              :style="{ 'aspect-ratio': item.jump_img_ratio ? item.jump_img_ratio : 'auto' }"
            />
          </a>
          <NuxtImgWrap
            v-else
            :src="item.jump_image"
            :alt="`Vooglam ${item.jump_image}`"
            loading="lazy"
            :style="{ 'aspect-ratio': item.jump_img_ratio ? item.jump_img_ratio : 'auto' }"
          />
        </div>
      </div>
      <div v-exposure="newsletterExposureOptions" class="newsletter-module">
        <div class="join">
          <p class="p1">Join Our Newsletter</p>
          <p class="p2">to enjoy more exclusive offers</p>
        </div>
        <form class="subscribe" @submit.prevent="subscribeClick">
          <label class="sr-only" for="footerSubscribeEmail">Enter Your Email</label>
          <input
            id="footerSubscribeEmail"
            v-model.trim="subscribeEmail"
            class="subscribe-l"
            type="text"
            maxlength="50"
            :disabled="!!token"
            placeholder="Enter Your Email"
          />
          <button class="subscribe-r" type="submit" @click="trackFooterSubscribeClick">
            {{ FOOTER_SUBSCRIBE_BUTTON_TEXT }}
          </button>
        </form>
      </div>
    </div>

    <div class="service-policy-module">
      <div
        v-for="(item, index) in servicePolicyModule"
        class="service-policy-module-item"
        :key="index"
      >
        <MagicJump :item="item.jump_info" :aria-label="item.title" :entrancePageScene="'底部导航'">
          <div class="service-policy-module-item-inner">
            <img
              :src="item.section_bg?.[0]?.cdn_full_image"
              :alt="item?.img_alt_info || 'Vooglam offers premium service warranty'"
              loading="lazy"
            />
            <span>{{ item.service_word }}</span>
          </div>
        </MagicJump>
      </div>
    </div>
    <div class="footers-c">
      <div class="cate-ul">
        <div v-for="item in classify_module" :key="item.id" class="cate-li">
          <div v-for="item1 in item.list" :key="item1.id" class="cate-li-div">
            <div class="cate-li-title">
              {{ item1.title }}
            </div>
            <div v-for="(item2, item2Index) in item1.children" :key="item2.id" class="cate-li-item">
              <MagicJump
                v-if="
                  !(
                    typeof item2.jump_target.Jump_target === 'string' &&
                    item2.jump_target.Jump_target?.includes('/contactUs') &&
                    item2.children_title === 'Contact Us'
                  )
                "
                targetType="href"
                :item="item2.jump_target"
                :aria-label="item2.children_title"
                :entrancePageScene="'底部导航'"
                @click="
                  SDHomeBottomNavigationTab_Click(
                    item1.title,
                    item1.firstLevelIndex,
                    item2.children_title,
                    item2Index,
                  )
                "
              >
                {{ item2.children_title }}
              </MagicJump>
              <a
                v-else
                :href="item2.jump_target.Jump_target"
                style="color: inherit"
                @click.prevent="goContactUs"
                >{{ item2.children_title }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footers-b">
      <MagicJump v-if="pay_module" :item="pay_module" :aria-label="`pay_module`">
        <NuxtImgWrap
          class="pay-img"
          :src="pay_module.jump_image"
          alt="pay_module"
          loading="lazy"
          width="1920"
          :entrancePageScene="'底部导航'"
          :style="{
            'aspect-ratio': pay_module.jump_img_ratio ? pay_module.jump_img_ratio : 'auto',
          }"
        />
      </MagicJump>
      <div class="footers-b-b">
        <div class="tiems">{{ currentYear }} <a href="/">Vooglam.com</a>. All rights reserved</div>
        <div class="footers-b-a">
          <router-link to="/privacySecurity"> Privacy & Security </router-link>
        </div>
        <div class="footers-b-border"></div>
        <div class="footers-b-a">
          <router-link to="/termsConditions"> Terms & Conditions </router-link>
        </div>
        <div class="footers-b-border"></div>
        <div class="footers-b-a">
          <a href="javascript:OneTrust.ToggleInfoDisplay()"> Cookies Notice </a>
        </div>
        <label class="sr-only" for="blindModeValue">blindModeValue</label>
        <el-switch
          id="blindModeValue"
          v-model="blindModeValue"
          class="accessibility"
          inactiveText="Accessibility"
          @change="onBlindClick"
        />
      </div>
    </div>
    <!-- 登录&注册弹窗 -->
    <client-only>
      <LoginRegister v-model:show="LRshow.value" :initialEmail="subscribeEmail" />
      <SubscribeConsentDialog v-model="subscribeConsentVisible" />
    </client-only>
  </div>
</template>
<script setup>
import { useStore } from '@/store';
import { EMAIL_REGEX } from '@/assets/js/common-regex';
import { ElMessage } from 'element-plus';
import { storeToRefs } from 'pinia';
import { computed, defineAsyncComponent } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const LoginRegister = defineAsyncComponent(() => import('@/components/auth/login-register.vue'));
const SubscribeConsentDialog = defineAsyncComponent(
  () => import('@/components/public/subscribe/SubscribeConsentDialog.vue'),
);

const router = useRouter();
const route = useRoute();
const store = useStore();

const { bffCsrData, bffSsrData, token, currentYear, blindMode, userInfo, marketingStatus } =
  storeToRefs(store);
const { SET_BLIND_MODE } = store;
const blindModeValue = ref(false);
const subscribeEmail = ref('');
const subscribeConsentVisible = ref(false);
const FOOTER_SUBSCRIBE_BUTTON_TEXT = 'SUBSCRIBE';
const newsletterExposureTimestamp = ref(Date.now());
const isEmailMarketingGranted = computed(() => !!marketingStatus.value?.marketing_granted?.email);
const newsletterExposureOptions = computed(() => ({
  callback: () => trackFooterNewsletter('EDMModule_Exp'),
  once: true,
  ts: newsletterExposureTimestamp.value,
}));
onMounted(() => {
  watch(
    () => blindMode,
    (val) => {
      blindModeValue.value = val;
    },
  );
  watch(
    () => route.fullPath,
    () => {
      newsletterExposureTimestamp.value = Date.now();
    },
  );
});

watch(
  () => [token.value, userInfo.value?.email, isEmailMarketingGranted.value],
  () => {
    if (token.value) {
      subscribeEmail.value = userInfo.value?.email || '';
      return;
    }
    subscribeEmail.value = '';
  },
  { immediate: true },
);

const inSearchPage = computed(() => {
  return (
    route.name == 'search' ||
    route.name == 'goodsDetail' ||
    route.name == 'Ambassadors' ||
    route.name == 'Represents' ||
    route.name == 'ProfilePage' ||
    route.name == 'TrendBookIndex' ||
    route.name == 'TrendBookReusedPage' ||
    route.name == 'TrendBookFestivalGudie' ||
    route.name == 'writeForUs' ||
    route.name == 'FestivalQuiz' ||
    route.name == 'BuyGet'
  );
});

const footNavData = computed(() => bffSsrData.value.foot_nav?.data_info || {});
const servicePolicyModule = computed(() => footNavData.value?.service_policy_module?.mainList);
const classify_module = computed(() => {
  const _list = footNavData.value?.classify_module || [];
  let _firstLevelIndex = -1;
  _list.forEach((item) => {
    item.list?.forEach((item1) => {
      _firstLevelIndex++;
      item1.firstLevelIndex = _firstLevelIndex;
    });
  });
  return _list;
});
const media_module = computed(() => footNavData.value?.media_module?.data_list || []);
const pay_module = computed(() => footNavData.value?.pay_module || {});

const LRshow = reactive({
  value: false,
});

const isValidSubscribeEmail = () => EMAIL_REGEX.test(subscribeEmail.value);

function subscribeClick() {
  if (token.value && isEmailMarketingGranted.value) {
    router.push({
      name: 'myAccount',
    });
    return;
  }
  if (!isValidSubscribeEmail()) {
    ElMessage.error('Please enter a valid email address.');
    return;
  }
  if (!token.value) {
    LRshow.value = true;
    return;
  }
  subscribeConsentVisible.value = true;
}

function trackFooterNewsletter(eventName, params = {}) {
  try {
    window.voo_sensors?.sensorsTrack(eventName, {
      page_name: route.meta?.cnName || '',
      ...params,
    });
  } catch (e) {
    console.log(e);
  }
}

function trackFooterSubscribeClick() {
  trackFooterNewsletter('EDMModule_Click', { btn_name: FOOTER_SUBSCRIBE_BUTTON_TEXT });
}

function onBlindClick(e) {
  SET_BLIND_MODE(e);
}
function SDHomeBottomNavigationTab_Click(
  first_tab_name,
  first_tab_index,
  second_tab_name,
  second_tab_index,
) {
  try {
    const sdEventName = 'BottomNavTab_Click';
    const sdEventParams = {
      page_name: route.meta?.cnName,
      url_path: window.location.href,
      first_tab_name,
      first_tab_index,
      second_tab_name,
      second_tab_index,
    };
    window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
  } catch (e) {
    console.log(e);
  }
}
function SDHomeSocialmedia_Click(btn_name, btn_jump_content, btn_jump_type) {
  try {
    const sdEventName = 'Socialmedia_Click';
    const sdEventParams = {
      page_name: route.meta?.cnName,
      url_path: window.location.href,
      btn_name,
      btn_jump_content,
      btn_jump_type,
    };
    window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
  } catch (e) {
    console.log(e);
  }
}

// 使用 props 中的 BFF 数据计算客服时间控制
const contactCtrl = computed(() => {
  const _data = bffCsrData.value.contact_chat_open_time || {};
  return {
    start: new Date(`1/1/1970 ${_data.start} UTC+0000`).getTime() - 8 * 60 * 60 * 1000,
    end: new Date(`1/1/1970 ${_data.end} UTC+0000`).getTime() - 8 * 60 * 60 * 1000,
  };
});

function getNowTime() {
  const now = Date.now();
  return new Date(
    `1/1/1970 ${(parseInt(now / 1000 / 60 / 60) % 24).toString().padStart(2, '0')}:${(
      parseInt(now / 1000 / 60) % 60
    )
      .toString()
      .padStart(2, '0')}:${(parseInt(now / 1000) % 60).toString().padStart(2, '0')} UTC+0000`,
  ).getTime();
}
const openInstadesk = inject('openInstadesk');

function goContactUs() {
  if (contactCtrl.value?.start <= getNowTime() && getNowTime() <= contactCtrl.value?.end) {
    // 联系我们
    openInstadesk();
  } else {
    router.push('/contactUs');
  }
}
</script>
<style lang="scss" scoped>
.footers {
  margin: 0 auto;
  padding: 0 48px;
  max-width: 2560px;
  font-family: $f-pr;
  color: #1a1c1e;
  background: #ffffff;
  .footers-t {
    margin-bottom: 30px;
    padding-top: 30px;

    @include flex(center, center);

    @include max-screen(1280px) {
      flex-direction: column;
      .join {
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .social-ul {
        margin-right: 0 !important;
      }
    }
    &.border-top {
      border-top: 1px solid #e3e1de;
    }
    .social-ul {
      @include flex;

      margin-right: 96px;
      .social-li {
        margin-right: 28px;
        width: 32px;
        height: 32px;

        @include flex(center, center);
        a {
          @include flex(center, center);

          width: 100%;
          height: 100%;
        }
        &:last-child {
          margin-right: 0;
        }
        img {
          display: block;
          width: 32px;
        }
      }
    }
    .footers-t-right {
      @include flex(normal, center);
    }
    .newsletter-module {
      @include flex(center, center);

      @include max-screen(1280px) {
        flex-direction: column;
      }
      .join {
        margin-right: 24px;
        text-align: center;

        @include max-screen(1280px) {
          margin-right: 0;
        }
        .p1 {
          line-height: 36px;
          font-size: 16px;
          font-family: $f-pb;
        }
        .p2 {
          line-height: 18px;
          font-size: 16px;
          font-family: $f-lr;
        }
      }
      .subscribe {
        margin: 0;
        width: 410px;
        height: 50px;

        @include flex;
        .subscribe-l {
          padding-left: 16px;
          min-width: 0;
          border: 1px solid #1a1c1e;
          border-radius: 4px 0 0 4px;
          font-size: 14px;
          font-family: $f-lr;
          color: #000000;
          background: #ffffff;
          outline: none;
          flex: 1;
          box-sizing: border-box;

          @include flex(normal, center);
          &::placeholder {
            color: #a9afb2;
          }
        }
        .subscribe-r {
          @include flex(center, center);

          position: relative;
          left: -2px;
          width: 118px;
          line-height: 18px;
          border: 0;
          border-radius: 4px;
          font-size: 14px;
          font-family: $f-pm;
          color: #ffffff;
          background: #1a1c1e;
          cursor: pointer;
        }
      }
    }
  }
  .service-policy-module {
    margin: 0 auto;
    padding: 46px 0 40px;
    max-width: 1620px;
    border-top: 1px solid #e3e1de;

    @include flex(center, center);
    .service-policy-module-item {
      margin-right: px-vw(130px);
      &:last-child {
        margin-right: 0;
      }

      @include max-screen(940px) {
        margin-right: px-vw(60px);
      }
    }
    .service-policy-module-item-inner {
      @include flex(center, center, column);
      img {
        display: block;
        margin-bottom: 16px;
        width: auto;
        height: 44px;
      }
      span {
        line-height: 24px;
        font-size: 16px;
        font-family: $f-pm;
        color: #080506;
      }
    }
  }
  .footers-c {
    margin: auto;
    padding: 60px 0 40px;
    max-width: 1620px;
    border-top: 1px solid #e3e1de;
    border-bottom: 1px solid #e3e1de;

    @include flex(center, center);
    .cate-ul {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(215px, 1fr));
      column-gap: 20px;
      width: 100%;
      .cate-li {
        margin-right: 0;
        margin-bottom: 40px;
        &:last-child {
          margin-right: 0;
        }
        .cate-li-div {
          margin-bottom: 40px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .cate-li-title {
          padding-bottom: 4px;
          line-height: max(16px, 18px);
          font-size: max(16px, 16px);
          font-family: $f-pb;
        }
        .cate-li-item {
          margin-top: 20px;
          line-height: 16px;
          font-size: 14px;
          font-family: $f-lr;
        }
      }
    }
  }
  .footers-b {
    padding: 20px 0 70px;
    .pay-img {
      display: block;
      width: 100%;
      height: auto;
    }
    .footers-b-b {
      margin-top: 28px;
      font-size: 14px;
      color: #5a544e;

      @include flex(center, center);
      a {
        color: #5a544e;
      }
      .tiems {
        margin-right: 20px;
      }
      .footers-b-a {
        padding: 0 20px;
        text-decoration: underline;
      }
      .footers-b-border {
        width: 1px;
        height: 14px;
        background: #908b7f;
      }
      .accessibility {
        margin-left: 20px;

        --el-switch-on-color: #fe5000;
        --el-switch-off-color: #e3e1de;
        :deep(.el-switch__label) {
          margin-right: 12px;
          font-family: $f-pb;
          color: #5a544e;
        }
      }
    }
  }
}
</style>
